'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = require('./config');

Object.defineProperty(exports, 'getConfig', {
  enumerable: true,
  get: function get() {
    return _config.getConfig;
  }
});
Object.defineProperty(exports, 'getBaseUrl', {
  enumerable: true,
  get: function get() {
    return _config.getBaseUrl;
  }
});
Object.defineProperty(exports, 'getProxy', {
  enumerable: true,
  get: function get() {
    return _config.getProxy;
  }
});
Object.defineProperty(exports, 'setConfig', {
  enumerable: true,
  get: function get() {
    return _config.setConfig;
  }
});
Object.defineProperty(exports, 'AppConfigType', {
  enumerable: true,
  get: function get() {
    return _config.AppConfigType;
  }
});
Object.defineProperty(exports, 'ProviderConfigType', {
  enumerable: true,
  get: function get() {
    return _config.ProviderConfigType;
  }
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/config/index.js
// module id = 43
// module chunks = 0